/**
 * useRicercaPazienti — la ricerca di un paziente dal telefono del medico
 * (proposta telefono-stile-nuovo, punti 2 e 4: il campo «Cerca un paziente
 * (nome o codice fiscale)» di «Oggi» e la scelta del paziente di «Scatta»).
 *
 * LA STESSA RICERCA DELLA PAGINA PAZIENTI, E QUINDI LA STESSA TRACCIA: la
 * rotta e' GET /api/pazienti?search= (pazientiAPI.getAll), che scrive la
 * ricerca nel registro degli accessi come la pagina Pazienti e come la barra
 * comandi (Ctrl K). Nessuna rotta nuova, nessun filtro qui: chi si trova lo
 * decide il server.
 *
 * Come la barra comandi (components/guscio/BarraComandi.jsx): si cerca per
 * parola, non per lettera - da MINIMO_PAZIENTI caratteri e dopo ATTESA ms di
 * pausa - perche' ogni ricerca resta nel registro, e «r», «ro», «ros» non
 * sono le ricerche di nessuno. Una risposta arrivata dopo una piu' nuova si
 * butta: conta l'ultima cosa scritta.
 */
import { useEffect, useRef, useState } from 'react';
import { pazientiAPI } from '../services/api';
import { messaggioDa } from '../utils/notifiche';
import { MINIMO_PAZIENTI, LIMITE_PAZIENTI } from '../navigazione/comandi';

export const ATTESA = 300;

export default function useRicercaPazienti(testo) {
    const [esito, setEsito] = useState({ stato: 'vuoto', elenco: [], messaggio: null });
    const giro = useRef(0);
    useEffect(() => {
        const q = String(testo || '').trim();
        giro.current += 1;
        const questo = giro.current;
        if (q.length < MINIMO_PAZIENTI) {
            setEsito({ stato: 'vuoto', elenco: [], messaggio: null });
            return undefined;
        }
        setEsito({ stato: 'cerco', elenco: [], messaggio: null });
        const t = setTimeout(async () => {
            try {
                const r = await pazientiAPI.getAll({ search: q, limit: LIMITE_PAZIENTI });
                if (questo !== giro.current) return;
                setEsito({ stato: 'fatto', elenco: (r.data && r.data.data && r.data.data.pazienti) || [], messaggio: null });
            } catch (e) {
                if (questo !== giro.current) return;
                setEsito({ stato: 'errore', elenco: [], messaggio: messaggioDa(e, 'Non riesco a cercare i pazienti') });
            }
        }, ATTESA);
        return () => clearTimeout(t);
    }, [testo]);
    return esito;
}
